module.exports = __webpack_public_path__ + "img/dashboard-mobile.f0a9852.webp";